import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

export default function QROverlay({ url, code, onClose }) {
  return (
    <div className="qr-overlay" onClick={onClose}>
      <div className="qr-panel" onClick={e => e.stopPropagation()}>
        <h3 className="qr-title">MITSPIELEN</h3>
        <div className="qr-code-wrapper">
          <QRCodeSVG
            value={url}
            size={200}
            bgColor="transparent"
            fgColor="#f0d060"
            level="M"
          />
        </div>
        <div className="qr-room-code">{code}</div>
        <p className="qr-hint">QR-Code scannen oder Code eingeben</p>
        <button className="qr-close" onClick={onClose}>SCHLIESSEN</button>
      </div>
    </div>
  );
}
